import type { RomaLocationCopy } from "@/lib/marketing-location-copy";

/** Subset of marketing copy fields used by reserve / location-picker chrome. */
export type RomaReserveLocation = Pick<
  RomaLocationCopy,
  | "slug"
  | "eyebrow"
  | "shortName"
  | "cityLabel"
  | "addressLine1"
  | "addressLine2"
  | "phoneDisplay"
  | "phoneHref"
  | "reserveUrl"
  | "firstPartyLocationId"
  | "hoursDetail"
  | "noteLine"
>;

export function sortRomaReserveLocations(
  locations: readonly RomaReserveLocation[],
): RomaReserveLocation[] {
  const order: RomaReserveLocation["slug"][] = [
    "southern-highlands",
    "henderson",
  ];

  return [...locations].sort(
    (a, b) => order.indexOf(a.slug) - order.indexOf(b.slug),
  );
}

export function isRomaReserveLocation(
  location: RomaReserveLocation,
): location is RomaReserveLocation & { slug: RomaLocationCopy["slug"] } {
  return location.slug === "southern-highlands" || location.slug === "henderson";
}
